module.exports = __webpack_public_path__ + "img/step1-c.2c72abf5.png";